import Consumer from './RootRefConsumer'
import generateContextHOC from 'onyx-common/generateContextHOC'

export default generateContextHOC(Consumer, 'rootRef')
